module.exports = __webpack_public_path__ + "static/img/reporticon11.afa5f7e6.png";